"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));
/* eslint-disable */
var _default = (0, _createIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M11.993 2.35c.614-.008 1.273.28 1.615.897l8.192 15.8c.1.2.2.5.2.8 0 1-.8 1.8-1.798 1.8H3.719c-.238 0-.412-.063-.623-.138a8.182 8.182 0 0 0-.177-.062c-.799-.5-1.198-1.5-.699-2.4 0 0 7.96-15.178 8.292-15.8.331-.622.868-.889 1.481-.897Zm-.883 6.397v5.4c0 .5.4.9.9.9s.9-.4.9-.9v-5.3c0-.5-.4-.9-.9-.9s-.9.4-.9.8ZM12 18.95a1.3 1.3 0 1 0 0-2.6 1.3 1.3 0 0 0 0 2.6Z"
})), "0 0 24 24", "Alert");
exports.default = _default;